import React from 'react';
import { colors } from '../styles';

const Median = ({ chart_height, point, stroke_width, chart_width }) => {
  return (
    <line
      aria-hidden="true"
      strokeWidth={stroke_width}
      x1="0"
      y1={chart_height - point}
      x2={chart_width - 20}
      y2={chart_height - point}
      stroke={colors.chart_bg}
    />
  );
};
export default Median;
